// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13tDx","title":"Header_title__1JJUO","left":"Header_left__PTAbn","clinicName":"Header_clinicName__6NUYs"};